import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState } from 'vuex';
import { fetchTemplateVersion } from '@/api/dmaker/custom';
import VersionTemplate from './list';
import CreateVersion from '@pt/components/createVersion';
import { createTemplateVersion, fetchNextCustomVersionId } from '@/api/dmaker/custom';
import ToggleButton from './toggle-button';
import { ptTrackEvent } from '@com/utils/report-logs/pt';

export default {
  components: {
    VersionTemplate: VersionTemplate,
    CreateVersion: CreateVersion,
    ToggleButton: ToggleButton
  },
  data: function data() {
    return {
      versionDialog: {
        template_id: '',
        visible: false,
        title: '',
        copy_id: '',
        copy_name: '',
        total: '0',
        requestLoading: false
      },
      sideVisible: false,
      // downloadDialog: {
      //   visible: false,
      //   list: [],
      // },
      customIds: [],
      templateId: 0,

      // 拷贝目标类型
      copyToTargetType: '',
      isMouseInSideBar: false
    };
  },

  computed: _extends({}, mapState({
    customId: function customId(state) {
      return state.creative.template.id;
    },
    pushPermissions: function pushPermissions(state) {
      return _.get(state, 'creative.template.templateConfig.is_pushable') || false;
    },
    isExpand: function isExpand(state) {
      return state.creative.template.workSpaceSetting.rightSideBar_isExpand;
    }
  }), {
    toggleButtonVisible: function toggleButtonVisible() {
      if (this.isExpand) {
        return this.isMouseInSideBar;
      }
      return true;
    }
  }),
  methods: {
    getListPromise: function getListPromise(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchTemplateVersion(data);

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleVersionCreate: function handleVersionCreate(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  template_id: item.template_id,
                  is_dco: 0
                };
                _context2.next = 3;
                return fetchNextCustomVersionId(data);

              case 3:
                res = _context2.sent;

                if (res.data.code === 0) {
                  _this2.versionDialog = {
                    template_id: item.template_id,
                    visible: true,
                    title: '',
                    total: _.get(res, 'data.data.next_version_id')
                  };
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleVersionCopy: function handleVersionCopy(_ref) {
      var _this3 = this;

      var params = _ref.params,
          type = _ref.type;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data, getNextCustomVersionRequest, request, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.copyToTargetType = type;
                data = {
                  template_id: params.template_id,
                  is_dco: 0
                };

                getNextCustomVersionRequest = function getNextCustomVersionRequest() {
                  return fetchNextCustomVersionId;
                };

                request = getNextCustomVersionRequest();
                _context3.next = 6;
                return request(data);

              case 6:
                res = _context3.sent;

                if (res.data.code === 0) {
                  _this3.versionDialog = {
                    template_id: params.template_id,
                    visible: true,
                    title: '',
                    total: _.get(res, 'data.data.next_version_id'),
                    copy_id: params.copy_id,
                    copy_name: params.copy_name
                  };
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleDownload: function handleDownload(item, template) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.customIds[0] = item.id;
                _this4.templateId = template.template_id;
                loading = _this4.getSaveLoading();
                _context4.prev = 3;
                _context4.next = 6;
                return _this4.$store.dispatch('creative/template/saveTemplate');

              case 6:
                _context4.next = 8;
                return _this4.$store.dispatch('creative/template/getTemplateInfo');

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](3);

                console.log(_context4.t0);

              case 13:
                loading.close();

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[3, 10]]);
      }))();
    },
    versionSideReset: function versionSideReset() {
      this.versionDialog = {
        template_id: '',
        visible: false,
        title: '',
        copy_id: '',
        copy_name: ''
      };
      this.versionDialog = {
        visible: false,
        list: []
      };
    },
    getSaveLoading: function getSaveLoading() {
      return this.$loading({
        lock: true,
        text: this.$t('playTurbo.common.versionBar.saveWarningText'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    saveConfirm: function saveConfirm(type) {
      var context = '' + this.$t('playTurbo.common.versionBar.saveConfirm.content');
      return this.$confirm(context, this.$t('playTurbo.common.versionBar.saveConfirm.title'), {
        class: 'save-confirm-dialog',
        confirmButtonText: this.$t('playTurbo.common.versionBar.saveConfirm.confirmButtonText'),
        cancelButtonText: this.$t('playTurbo.common.versionBar.saveConfirm.cancelButtonText'),
        type: 'warning'
      });
    },
    handleCreateVersion: function handleCreateVersion(params) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var createVersionRequest, navigateToNewVersion, res, templateId, customId, action;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                createVersionRequest = function createVersionRequest(data) {
                  // 普通制作
                  return createTemplateVersion(data);
                };

                navigateToNewVersion = function navigateToNewVersion(_ref2) {
                  var templateId = _ref2.templateId,
                      customId = _ref2.customId;

                  _this5.$router.push({
                    path: '/creative-service/playable/' + templateId + '/custom/' + customId
                  });
                };

                _this5.versionDialog.requestLoading = true;
                _context5.next = 5;
                return createVersionRequest(params);

              case 5:
                res = _context5.sent;

                _this5.versionDialog.requestLoading = false;
                _this5.$message({
                  type: 'success',
                  message: _this5.$t('playTurbo.common.createVersionDialog.createSuccessText')
                });
                templateId = _.get(res, 'data.data.template_id');
                customId = _.get(res, 'data.data.custom_id');

                // 如果是复制到其他类型，普通制作才有复制到其他类型功能

                _this5.versionDialog.visible = false;
                action = ptTrackEvent.createAction();

                action.log({
                  e: 'create_project',
                  extra: {
                    pid: customId,
                    source_page: 'editing',
                    project_type: 'dm'
                  }
                });
                navigateToNewVersion({
                  customId: customId,
                  templateId: templateId
                });

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  mounted: function mounted() {},

  watch: {
    $route: function $route() {
      this.versionSideReset();
    },
    'versionDialog.visible': function versionDialogVisible(val) {
      // 版本创建弹窗关闭后，重置 copyToTargetType
      if (val === false) this.copyToTargetType = '';
    }
  }
};